import { ReactNode } from 'react';
import TaskIcon from '@/assets/icons/TaskIcon';
import NoteTakerIcon from '@/assets/icons/NoteTakerIcon';
import CallTransferIcon from '@/assets/icons/CallTransferIcon';
import GeneralQueryIcon from '@/assets/icons/GeneralQueryIcon';
import EndCallIcon from '@/assets/icons/EndCallIcon';

export function getWorkflowNodeIcon(type?: string, size = 20): ReactNode {
  if (!type) return null;

  switch (type) {
    case 'task':
    case 'order_taking':
      return <TaskIcon width={size} height={size} />;
    case 'note_taking':
      return <NoteTakerIcon width={size} height={size} />;
    case 'call_transfer':
      return <CallTransferIcon width={size} height={size} />;
    case 'general_inquiry':
      return <GeneralQueryIcon width={size} height={size} />;
    case 'end_call':
      return <EndCallIcon width={size} height={size} />;
    default:
      return null;
  }
}
